import { 
  asphaltMixes,
  coldBinReadings,
  hotBinReadings,
  labResults,
  plants,
  temperatureReadings,
} from '@/mock/minds.json'
import axios from 'axios'

export default {
  async fetchPlants({ commit }) {
    const { data } = await axios.get('/minds')

    commit('updatePlants', data.plants)
    commit('updateAsphaltMixes', data.asphaltMixes)

    // Comment top and uncomment bottom to use mocked data instead of minds route
    // commit('updatePlants', plants)
    // commit('updateAsphaltMixes', asphaltMixes)

  },
  async fetchMindsData({ commit, getters }, { asphaltMixId }) {
    const { data } = await axios.get(`/minds/${asphaltMixId}`)

    commit('updateTemperatureReadings', data.temperatureReadings)
    commit('updateHotBinReadings', data.hotBinReadings)
    commit('updateColdBinReadings', data.coldBinReadings)
    commit('updateLabResults', data.productionLabResults)
  },
}
